/* eslint-disable  */
/*
 * Error Interceptor used all http services to handle error.
 * So we can not specify type of HttpRequest and HttpEvent.
 */
import { isPlatformBrowser } from '@angular/common';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, TimeoutError, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoggingService } from '../../logging/logging.service';
import { TrackJs } from './models/trackjs.interfaces';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private logging: LoggingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse)
          if (
            !event.body ||
            (event.body &&
              event.body.hasOwnProperty('error') &&
              Object.keys(event.body.error).length)
          )
            throw this.generateHttpErrorResponse(event.body, event.status);
        return event;
      }),
      catchError((err: HttpErrorResponse) => {
        return this.handleError(err, request);
      })
    );
  }

  generateHttpErrorResponse(error: any, errorCode: number): HttpErrorResponse {
    this.trackErrorInTrackJs(errorCode.toString(), JSON.stringify(error.error));
    return new HttpErrorResponse({
      status: 500,
      statusText: 'Backend Error',
      error
    });
  }

  handleError(
    err: HttpErrorResponse,
    request: HttpRequest<any>
  ): Observable<HttpEvent<any>> {
    this.trackErrorInTrackJs(err.toString(), err.message);
    if (err instanceof TimeoutError) {
      this.logging.log(`Timeout error: Service: ${request.url} ${err.message}`);
    } else {
      this.handleAPIError(err, request);
    }
    return throwError(err);
  }

  trackErrorInTrackJs(errorCode: string, error: string) {
    try {
      this.logging.addMetadata('errorCode', errorCode);
      window?.trackJs?.track(error);
      (<TrackJs>window?.trackJs)?.removeMetadata('errorCode');
      if (isPlatformBrowser(this.platformId)) {
        this.logging.addMetadata('TeaLeafId', this.logging.getTealeafId());
      }
    } catch {
      console.error(error);
    }
  }

  handleAPIError(err: HttpErrorResponse, request: HttpRequest<any>) {
    const statusCodeArr = [403, 404, 500, 502, 503];
    if (statusCodeArr.indexOf(err.status) !== -1) {
      this.errorMessage(err);
    } else {
      this.logging.log(
        `HTTP Interceptor Error: Service: ${request.url} ${err.message} : ${err.status} ${err.statusText}`
      );
    }
  }

  errorMessage(err: HttpErrorResponse) {
    let urlSegments, serviceName;
    if (err.url) {
      if (err.url.indexOf('?') !== -1) {
        urlSegments = err.url.split('?')[0].split('/');
        serviceName = urlSegments[urlSegments.length - 1];
      } else {
        urlSegments = err.url.split('/');
        serviceName = urlSegments[urlSegments.length - 1];
      }
      this.logging.log(`${serviceName} is returning ${err.status}`);
    }
  }
}
